"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getImageTag = void 0;
/**
 * Given a data64Url of an image (maybe from a canvas?), this will return a `HTMLImageElement`.
 */
const getImageTag = async (imageDataUrl) => {
    return new Promise(resolve => {
        const image = new Image();
        image.onload = () => {
            resolve(image);
        };
        image.src = imageDataUrl;
    });
};
exports.getImageTag = getImageTag;
//# sourceMappingURL=getImage.js.map